module.exports = __webpack_public_path__ + "202408221624/img/img_help_texture.a76bd9f3.png";